import type { Resource } from '../../';
export const product_details_contentBlocks_freeShipping_modal_paragraph2: Resource = {"default":"Applies to full priced orders."};
